"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOrgGeneralSettings = void 0;
const react_1 = require("react");
const context_1 = require("../context");
const useOrgGeneralSettings = () => {
    const { selectedOrgUser } = (0, react_1.useContext)(context_1.OrganizationContext);
    const [settings, setSettings] = (0, react_1.useState)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [isSaving, setIsSaving] = (0, react_1.useState)(false);
    const [hasLoadError, setHasLoadError] = (0, react_1.useState)(false);
    const load = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!selectedOrgUser)
            return;
        try {
            setIsLoading(true);
            setHasLoadError(false);
            setSettings(yield selectedOrgUser.fetchGeneralSettings());
        }
        catch (_a) {
            setHasLoadError(true);
        }
        finally {
            setIsLoading(false);
        }
    }), [selectedOrgUser]);
    (0, react_1.useEffect)(() => {
        load();
    }, [load]);
    const save = (request) => __awaiter(void 0, void 0, void 0, function* () {
        if (!selectedOrgUser)
            throw new Error("No organization selected");
        try {
            setIsSaving(true);
            setSettings(yield selectedOrgUser.saveGeneralSettings(request));
        }
        finally {
            setIsSaving(false);
        }
    });
    return { settings, isLoading, isSaving, hasLoadError, reload: load, save };
};
exports.useOrgGeneralSettings = useOrgGeneralSettings;
